<div [id]="uniqueComponentId('input-')" class="c-radio-checkbox">
  <input type="checkbox"
         [id]="uniqueElementId"
         [(ngModel)]="checked"
         [ngModelOptions]="{standalone: true}"
         (blur)="propagateTouch()"
         [disabled]="isDisabled"
         #checkElement/>
  <label [for]="uniqueElementId" class="o-checkradio__label t-check"
         [title]="this.toolTipDisabled">{{config.label}}<i
      class="o-btn-tooltip-help"
      *ngIf="config.toolTip"
      [title]="config.toolTip"
      placement="auto">?</i>
  </label>
</div>
